// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1179":"f6ec2f5e","1484":"f6ec2f5e","2976":"c7fae2f8","5861":"7c0d90b7"}[chunkId] + ".chunk.css";
};